module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-5-bc48760054427083ad87c70c96238bbc.svg";